<div class="global-loader">
  <app-loading-bar [hidden]="(loading$ | async) === false"></app-loading-bar>
</div>
